import React, {Component} from 'react';
import {getMarkdownContent} from '../utils/utils';
import isArray from 'lodash/isArray';

/*

var deleteLinks = document.querySelectorAll('.remark-visible .remark-code-line');

Array.from(deleteLinks).forEach((link, index) => {
    link.addEventListener('click', function(event) {
        console.log(index)
    });
})

 */
export const cycleValueAround = (current, change, max) => {
  const changed = current + change;

  if (changed === max) {
    return current;
  } else if (changed === -1) {
    return current;
  }

  return changed;
};

const DIRECTIONS = {
  LEFT: 'left',
  RIGHT: 'right'
};

const hlClass = 'remark-code-line-highlighted';

class Presentation extends Component {
  state = {
    show: false,
    lines: [],
    highlighted: null
  };

  moveHiglighted = direction => {
    const {highlighted, lines} = this.state;
    let newValue = 0;

    if (highlighted === null) {
      newValue = 0;
    } else {
      newValue = cycleValueAround(
        highlighted,
        direction === DIRECTIONS.LEFT ? -1 : 1,
        lines.length
      );
    }

    this.setState({highlighted: newValue});
  };

  initSlideshow = () => {
    const {data: {sitePage: {context}}} = this.props;
    const {content, fileName} = context;

    this.slideshow = window.remark.create({
      source: getMarkdownContent(content),
      highlightLines: true,
      highlightStyle: 'dark',
      highlightSpans: false,
      highlightLanguage: 'javascript',
      navigation: {
        scroll: false
      },
      container: this.ref
    });

    setTimeout(() => {
      if (window.location.hash) {
        const hash = parseInt(window.location.hash.split('#')[1]);
        const currentIndex = this.slideshow.getCurrentSlideIndex();
        if (currentIndex !== hash) {
          this.slideshow.gotoSlide(hash);
          this.setState({
            show: true
          });
        }
      } else {
        this.setState({
          show: true
        });
      }
    }, 0);

    this.slideshow.on('afterShowSlide', slide => {
      const elemId = document.querySelector(
        '.remark-visible .remark-slide-content'
      ).id;

      if (elemId) {
        this.clearCurrentClasses();
        const lines = elemId.split('slide-')[1].split(',');
        const linesState = [];
        lines.forEach(line => {
          if (line.includes('-')) {
            const [from, to] = line.split('-');
            linesState.push([parseInt(from), parseInt(to)]);
          } else if (line !== '' && line.trim() !== '') {
            linesState.push(parseInt(line));
          }
        });
        this.setState({lines: linesState, highlighted: null});
      } else {
        this.setState({highlighted: null, lines: []});
      }
      window.location.hash = slide.getSlideIndex() + 1;
    });

    try {
      const initExample = require(`../../presentations/${fileName}/${fileName}.js`);
      setTimeout(initExample, 1000);
    } catch (err) {}
  };

  componentDidMount() {
    window.addEventListener('keydown', this.onKeyDown);
    this.initSlideshow();
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.onKeyDown);
  }

  onKeyDown = e => {
    const keys = {
      i: () => this.moveHiglighted(DIRECTIONS.LEFT),
      o: () => this.moveHiglighted(DIRECTIONS.RIGHT),
      r: this.resetHighlightedLines
    };

    keys[e.key] && keys[e.key]();
  };

  clearCurrentClasses = () => {
    document
      .querySelectorAll('.remark-visible .remark-code-line')
      .forEach(line => {
        line.classList.remove(hlClass);
      });
  };

  resetHighlightedLines = () => {
    this.clearCurrentClasses();
    this.setState({highlighted: null});
  };

  getCurrentLines = () =>
    document.querySelectorAll('.remark-visible .remark-code-line');

  componentWillUpdate(nextProps, {highlighted}) {
    if (highlighted !== null && this.state.highlighted !== highlighted) {
      const lines = this.getCurrentLines();
      this.clearCurrentClasses();

      const currentLine = this.state.lines[highlighted];

      lines.forEach((line, index) => {
        if (isArray(currentLine)) {
          const [from, to] = currentLine;
          if (index >= from - 1 && index <= to - 1) {
            line.classList.add(hlClass);
          }
        } else {
          if (index === currentLine - 1) {
            line.classList.add(hlClass);
          }
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (window.location.hostname === 'localhost') {
      // this.setState({show: false}, () => {
      // this.initSlideshow();
      // });
    }
  }

  render() {
    const {show, lines} = this.state;
    return (
      <div>
        <div
          ref={ref => {
            this.ref = ref;
            if(ref){
              ref.focus();
              ref.click();
            }
          }}
          style={{width: '100vw', height: '100vh', opacity: show ? 1 : 0}}
        />
        {lines.length > 0 && <div className="dot" />}
      </div>
    );
  }
}

export const query = graphql`
  query CurrentPresentation($slug: String!) {
    sitePage(context: {slug: {eq: $slug}}) {
      context {
        slug
        content
      }
    }
  }
`;

export default Presentation;



// WEBPACK FOOTER //
// ./src/templates/presentation.js